import React from 'react';
import { Yes, UpArrow } from '../icons/Icons';

const PageThree = (props) => {
  return (
    <div className="kids-quiz__page">
      <h1>Now, let's explore your diet.</h1>

      <div className="kids-quiz__question">
        <p className="question__title">Do you follow a specific diet?</p>
        <div className="radio-answers answers-row--2">
          <input type="radio" name="diet-radio" id="dietYes" value="yes" onChange={props.onSpecificDietClick} checked={props.specificDiet === 'yes'} />
          <label className="answer-button" htmlFor="dietYes">Yes</label>

          <input type="radio" name="diet-radio" id="dietNo" value="no" onChange={props.onSpecificDietClick} checked={props.specificDiet === 'no'} />
          <label className="answer-button" htmlFor="dietNo">No</label>
        </div>
      </div>

      {props.specificDiet === 'yes' ?
        <>
          <a href="#diets" className={`question-divider ${props.specificDiet ? 'question-divider--show' : ''}`}>
            <UpArrow />
          </a>
          <div id="diets" className="kids-quiz__question">
            <p className="question__title">Select below?</p>
            <div className="answers-row--flex diet-answers">
              {props.renderDietAnswers}
            </div>
          </div>
        </>
        :
        <a href="#cranky" className={`question-divider ${props.specificDiet ? 'question-divider--show' : ''}`}>
          <UpArrow />
        </a>
      }

      <a href="#cranky" className={`question-divider ${props.dietAnswersIndex.length !== 0 ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="cranky" className={`kids-quiz__question ${props.specificDiet === 'no' || (props.specificDiet === 'yes' && props.dietAnswersIndex.length !== 0) ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">Do you get hungry or have dips in energy between meals?</p>
        <div className="radio-answers answers-row--2">
          <input type="radio" name="hungry" id="hungryYes" value="yes" onChange={props.logHungryAnswer} checked={props.hungryBetweenMeals === 'yes'} />
          <label className="answer-button" htmlFor="hungryYes">Yes</label>

          <input type="radio" name="hungry" id="hungryNo" value="no" onChange={props.logHungryAnswer} checked={props.hungryBetweenMeals === 'no'} />
          <label className="answer-button" htmlFor="hungryNo">No</label>
        </div>
      </div>

      <a href="#foodGrid" className={`question-divider ${(props.hungryBetweenMeals && props.specificDiet === 'no')
        || (props.hungryBetweenMeals && props.specificDiet === 'yes' && props.dietAnswersIndex.length !== 0) ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="foodGrid" className={
        `kids-quiz__question 
        ${(props.hungryBetweenMeals && props.specificDiet === 'no')
          || (props.hungryBetweenMeals && props.specificDiet === 'yes' && props.dietAnswersIndex.length !== 0)
          ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">How often do you consume the below in an average day?</p>
        <div className="foods-grid">
          <div className="foods-title foods-title--empty"></div>
          <div className="foods-title foods-title--pf">Processed food</div>
          <div className="foods-title foods-title--fv">Fruit & veg</div>
          <div className="foods-category foods-category--rare">Rarely</div>
          <div className="foods-category foods-category--1-2">1-2 times a day</div>
          <div className="foods-category foods-category--3-4">3-4 times a day</div>
          <div className="foods-category foods-category--5">5+ times a day</div>
          <div className="foods-radio--pf--rare">
            <input type="radio" name="processed-food" id="processedFoodRarely" value="yes" onChange={props.handleFoodRadios} checked={props.processedFoodAnswer === 'processedFoodRarely'} />
            <label htmlFor="processedFoodRarely"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--pf--1-2">
            <input type="radio" name="processed-food" id="processedFood12" value="yes" onChange={props.handleFoodRadios} checked={props.processedFoodAnswer === 'processedFood12'} />
            <label htmlFor="processedFood12"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--pf--3-4">
            <input type="radio" name="processed-food" id="processedFood34" value="yes" onChange={props.handleFoodRadios} checked={props.processedFoodAnswer === 'processedFood34'} />
            <label htmlFor="processedFood34"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--pf--5">
            <input type="radio" name="processed-food" id="processedFood5" value="yes" onChange={props.handleFoodRadios} checked={props.processedFoodAnswer === 'processedFood5'} />
            <label htmlFor="processedFood5"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--fv--rare">
            <input type="radio" name="fruit-veg" id="fruitVegRarely" value="yes" onChange={props.handleFoodRadios} checked={props.fruitVegAnswer === 'fruitVegRarely'} />
            <label htmlFor="fruitVegRarely"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--fv--1-2">
            <input type="radio" name="fruit-veg" id="fruitVeg12" value="yes" onChange={props.handleFoodRadios} checked={props.fruitVegAnswer === 'fruitVeg12'} />
            <label htmlFor="fruitVeg12"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--fv--3-4">
            <input type="radio" name="fruit-veg" id="fruitVeg34" value="yes" onChange={props.handleFoodRadios} checked={props.fruitVegAnswer === 'fruitVeg34'} />
            <label htmlFor="fruitVeg34"><Yes className="radio-yes" /></label>
          </div>
          <div className="foods-radio--fv--5">
            <input type="radio" name="fruit-veg" id="fruitVeg5" value="yes" onChange={props.handleFoodRadios} checked={props.fruitVegAnswer === 'fruitVeg5'} />
            <label htmlFor="fruitVeg5"><Yes className="radio-yes" /></label>
          </div>
        </div>
      </div>
      <div className={`next-page ${props.processedFoodAnswer && props.fruitVegAnswer ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('3')}>Continue</div>
    </div>
  );
}

export default PageThree;